import { capitalizeFirstLetter } from "@payment-ui/helpers/String";
import React, { memo } from "react";
import cx from "classnames";
import styles from "../PaymentGroup.v4.scss";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { GroupIconPosition } from "@payment-ui/interfaces";
import { isEmpty } from "@swiggy-private/js-utils";

interface PaymentGroupTitleProps {
    title: string;
    bannerMessage?: string;
    disableMessage?: string;
    groupIcon?: string;
    groupIconPosition?: GroupIconPosition;
    groupSubtext?: string;
    "data-testid"?: string;
    bannerMessageTestId?: string;
    capitalizeTitle?: boolean;
}
const GROUP_ICON_HEIGHT = 16;

function PaymentGroupTitle({
    title,
    bannerMessage,
    bannerMessageTestId,
    "data-testid": dataTestId,
    capitalizeTitle = false,
    groupIcon,
    groupIconPosition,
    groupSubtext,
}: PaymentGroupTitleProps): React.ReactElement {
    const groupIconRight = !!(groupIconPosition && groupIconPosition === GroupIconPosition.RIGHT);
    const headerClassName = cx(styles.paymentGroupHeader, {
        [styles.paymentGroupHeaderWithSubtext]: !isEmpty(groupSubtext),
    });
    return (
        <div className={headerClassName}>
            <div className={styles.paymentGroupHeaderTitleContainer}>
                {groupIcon && !groupIconRight && (
                    <Image
                        className={styles.paymentGroupHeaderGroupIconLeft}
                        cloudinaryId={groupIcon}
                        height={`${GROUP_ICON_HEIGHT}px`}
                        cloudinaryHeight={GROUP_ICON_HEIGHT * 4}
                        alt=""
                    />
                )}
                <h2 className={styles.paymentGroupHeaderTitle} data-testid={dataTestId}>
                    {capitalizeTitle ? capitalizeFirstLetter(title) : title}
                </h2>
                {groupIcon && groupIconRight && (
                    <Image
                        className={styles.paymentGroupHeaderGroupIconRight}
                        cloudinaryId={groupIcon}
                        height={`${GROUP_ICON_HEIGHT}px`}
                        cloudinaryHeight={GROUP_ICON_HEIGHT * 4}
                    />
                )}
            </div>
            {groupSubtext && (
                <h3 className={styles.paymentGroupHeaderSubtext} data-testid={`${dataTestId}_subtext`}>
                    {groupSubtext}
                </h3>
            )}

            {bannerMessage && bannerMessage.length > 0 && (
                <div className={styles.paymentGroupHeaderBannerMessage} data-testid={bannerMessageTestId}>
                    {bannerMessage}
                </div>
            )}
        </div>
    );
}

export default memo(PaymentGroupTitle);
